export { default } from './MaterialTypeFilterLinks';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/MaterialTypeFilterLinks/index.js